import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export default (function (_ref) {
  var id = _ref.id,
      el = _ref.el,
      payload = _ref.payload,
      isCookieDebug = _ref.isCookieDebug;
  var data = payload.data,
      fn = payload.fn;
  var eventType = fn !== null && fn !== void 0 ? fn : 'track-event';
  if (process.client && !!isCookieDebug) console.info('generic-tracking ', {
    id: id,
    el: el,
    data: data
  });
  if (window && window.mdm_events) window.mdm_events(id, el, eventType, data);
});